module.exports = __webpack_public_path__ + "img/IMG_3884.6c65720b.jpg";